module.exports = __webpack_public_path__ + "static/media/full_screen.b06af950.svg";